import { useSelector } from "react-redux";
import { selectUserStep } from "../../store/reducers/users/users.selectors";
import { useDispatch } from "react-redux";
import ProgressBar from "../UI/ProgressBar";
import StepAccount from "./steps/StepAccount";
import StepPersonal from "./steps/StepPersonal";
import StepContact from "./steps/StepContact";
import StepInstitution from "./steps/StepInstitution";
import { createUserThunk, getUsersThunk, getUserByIdThunk } from "../../store/reducers/users/users.thunks";
import { resetForm } from "../../store/reducers/users/usersForm.slice";
import { openViewModal } from "../../store/reducers/users/users.reducer";
import { toast } from 'react-toastify';

const UserFormWizard = ({ onSuccess }) => {
  const step = useSelector(selectUserStep);

  const dispatch = useDispatch();

  const submitForm = async () => {
    const result = await dispatch(createUserThunk());
    if (result.meta.requestStatus === "fulfilled") {
      const createdId = result.payload.data.id;
      // Recargar la lista después de crear
      dispatch(getUsersThunk({ page: 1, search: "" }));
      // Resetear formulario
      dispatch(resetForm());
      toast.success('Usuario creado exitosamente');
      // Cerrar el modal
      if (onSuccess) {
        onSuccess();
      }
      // Abrir modal de vista con el nuevo registro
      await dispatch(getUserByIdThunk(createdId));
      dispatch(openViewModal());
    }
  };

  return (
    <div className="card shadow-sm border-0">
      <div className="card-body">
        <ProgressBar />

        {step === 1 && <StepAccount />}
        {step === 2 && <StepPersonal />}
        {step === 3 && <StepContact />}
        {step === 4 && <StepInstitution submit={submitForm} />}
      </div>
    </div>
  );
};

export default UserFormWizard;
